import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const MapSvg = styled.svg`
  display: block;
  width: 100%;
  max-width: 100rem;
  max-width: calc(3 * var(--col-width) + var(--gap));
  margin: 0 auto;
  overflow: visible;
  opacity: 1;
  transition-delay: 0.5s;
  transition: all 1s;
  ${mq.large} {
    /*margin-inline: 0;*/
  }
  &.out {
    transform: translateY(12vw);
    opacity: 0;
  }
  ${mq.smallOnly} {
    .infoCircle {
      transform: scale(1.6);
    }
    .infoText {
      transform: scale(1.6);
    }
  }
`

export const Text = styled.text`
  fill: var(--text-color);
  white-space: pre;
  font-family: 'Skolar Sans PE Condensed';
  font-size: 10px;
  letter-spacing: 0em;
  ${mq.smallOnly} {
    font-size: 13px;
  }
`

export const Label = styled(Text)`
  text-anchor: middle;
  translate: 0.5em;
  pointer-events: none;
  &.outside {
    ${mq.smallOnly} {
      font-size: 15px;
    }
  }
  &.right {
    text-anchor: end;
  }
`

export const WhiteLabel = styled(Label)`
  fill: white;
`

export const Region = styled.path`
  cursor: pointer;
  fill: var(--text-color);
  transition: 0.2s fill;

  &[data-active='true'] {
    fill: ${theme.colors.accent.rfe};
  }

  &:not([data-active='true']):hover {
    fill: #47606c;
  }
`

export const TotalDeathsText = styled.g`
  ${mq.large} {
    transform: translateX(141px) scale(0.8);
    transform-origin: 100% 100%;
  }
`
